var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStyleTextDecorationCapitalize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "#323C47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91567 3.33301C6.35057 3.33301 6.73561 3.6141 6.86812 4.02833L9.38907 11.909C9.50923 12.2846 9.22197 12.6663 8.81913 12.6663H8.27895C8.01778 12.6663 7.78691 12.5005 7.70901 12.257L7.09354 10.333H4.40647L3.79077 12.2577C3.71287 12.5012 3.48223 12.6663 3.22105 12.6663H2.68088C2.27803 12.6663 1.99077 12.2846 2.11093 11.909L4.63189 4.02833C4.76439 3.6141 5.14943 3.33301 5.58434 3.33301H5.91567ZM4.77967 9.16634L5.75 5.33301L6.72034 9.16634H4.77967Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 9.99967C14.75 10.6663 14.0833 12.6663 12.4167 12.6663C10.9439 12.6663 9.75 11.4724 9.75 9.99967C9.75 8.52692 10.9439 7.33301 12.4167 7.33301C14.0833 7.33301 14.75 9.33301 14.75 9.99967ZM13.9167 9.99967C13.9167 10.6663 13.4167 11.333 12.4167 11.333C11.6312 11.333 11.0833 10.7361 11.0833 9.99967C11.0833 9.26329 11.6312 8.66634 12.4167 8.66634C13.4167 8.66634 13.9167 8.99967 13.9167 9.99967Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7636 8.08131C13.7546 8.02698 13.7483 7.97174 13.7551 7.91707C13.7957 7.58786 14.0764 7.33301 14.4167 7.33301H14.75C15.1182 7.33301 15.4167 7.63148 15.4167 7.99967V11.9997C15.4167 12.3679 15.1182 12.6663 14.75 12.6663H14.4167C14.0764 12.6663 13.7957 12.4115 13.7551 12.0823C13.7483 12.0276 13.7546 11.9724 13.7636 11.918L13.9167 10.9997V9.99967V8.99967L13.7636 8.08131Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleTextDecorationCapitalize);
export default __webpack_public_path__ + "static/media/styleTextDecorationCapitalize.6d4ce3cc.svg";
export { ForwardRef as ReactComponent };